import React, { Component, useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { qr_code } from '../../Images';
import moment from 'moment';
import { NumberFormat } from '../../Components/NumberFormat';
import angkaTerbilang from '@develoka/angka-terbilang-js';
import { REACT_APP_BASE_URL } from '../../Constants';

const PrintPO = forwardRef((props, ref) => {
    const { getState, login } = props;
    const pageStyle =" @page { size: A4 portrait; margin: 20;}";
    const [qrCode, setQrCode] = useState("");

    useEffect(() => {
            let word = `${REACT_APP_BASE_URL}estatement/purchaseorder/${getState.order_no}`;
            setQrCode('https://api.qrserver.com/v1/create-qr-code/?data=' + word+ '&size=400x400&bgcolor=ffff');
    },[getState]);

    return (
        
        <div id="content" ref={ref} style={{color: '#000', backgroundColor: '#fff'}}>
            <style>{pageStyle}</style>
            <div style={{display: 'flex', flexWrap:'wrap', padding: 15}} >
                <div style={{width: '50%'}}>
                    <h2>{login.BPLFrName}</h2>
                    {login.legal_name && <h4>{login.legal_name}</h4>}
                    <p style={{fontSize: 18}}>{login?.Address}<br />
                        {login?.phone && <span>Telp {login?.phone}</span>}</p>  
                </div>
                <div style={{width: '15%'}}></div>
                <div style={{width: '35%', textAlign: 'right'}}>
                    <div style={{display: 'flex', flexWrap:'wrap', padding: 0}} >
                        <div style={{width: '70%', paddingRight:10,marginRight:0}}>
                            <h2 style={{fontSize: 18, fontWeight: 'bold'}}>No Order : <br/>
                            {getState.order_no}</h2>
                            <p style={{margin: 0}}>Tgl Order : { moment(getState.docduedate).format('DD MMMM YYYY') }</p>
                        </div>
                        <div style={{width: '30%', paddingLeft:0, marginLeft: 0}}>
                            <img src={qrCode} width={100} />
                        </div>
                    </div>
                    
                </div>
               
            </div>
            <div className='row justify-content-center' >
                <div style={{fontSize: 24, fontWeight: 'bold'}}> PURCHASE ORDER</div>
            </div>
            <hr />
            <div className='row' style={{margin: 10, padding: 10, paddingBottom: 0, marginBottom: 0}}>
                <div style={{fontWeight: 500, margin: 0, padding: 0}}>Ship To:</div>
            </div>
            <div className='row' style={{margin: 10, padding: 10, paddingTop: 0, marginTop:0}}>
                <table style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td>Nama</td>
                            <td style={{paddingLeft: 5, paddingRight: 5}}>:</td>
                            <td>{getState.shipping_name}</td>
                        </tr>
                        {/* <tr>
                            <td>Telepon</td>
                            <td style={{paddingLeft: 5, paddingRight: 5}}>:</td>
                            <td></td>
                        </tr> */}
                        <tr>
                            <td style={{verticalAlign: 'top'}}>Address</td>
                            <td style={{verticalAlign: 'top',paddingLeft: 5, paddingRight: 5}}>:</td>
                            <td>{getState.shipping_address}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='row' style={{margin: 10, padding: 10}}>
                <table className='table'>
                    <thead>
                        <tr>
                            <td style={{color: '#000'}}>NO</td>
                            <td style={{color: '#000'}}>Product</td>
                            <td style={{color: '#000'}}>Quantity</td>
                            <td style={{textAlign: 'right',color: '#000'}}>Unit/Price</td>
                            <td style={{textAlign: 'right',color: '#000'}}>PPN</td>
                            {/* <td>PPH</td> */}
                            <td style={{ textAlign: 'right',color: '#000'}}>Total</td>
                        </tr>
                    </thead>
                    <tbody>
                    {getState.detail.map((row, index) => 
                        (
                        <>
                            <tr key={`tr-` + index} style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                    <td style={{borderTop: 'none',color: '#000'}}>{index+1}</td>
                                    <td style={{borderTop: 'none',color: '#000'}}>{row.itemname}</td>
                                    <td style={{borderTop: 'none',color: '#000'}}>{row.qty}</td>
                                    <td style={{borderTop: 'none', textAlign: 'right',color: '#000'}}>{NumberFormat(row.price)}</td>
                                    <td style={{borderTop: 'none', textAlign: 'right',color: '#000'}}>{row.ppn}%</td>
                                    {/* <td style={{borderTop: 'none'}}>1.350.000</td> */}
                                    <td style={{borderTop: 'none', textAlign: 'right',color: '#000'}}>{NumberFormat(row.subtotal)}</td>
                            </tr>
                            { row.paketid && row.free==0 &&
                            <>
                                <tr key={`tr-` + index} style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                    <td colSpan={2}></td>
                                    <td colSpan={3} style={{fontSize: 16, paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{row.paket_name}</td>
                                    <td style={{paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{NumberFormat(row.disc_item)}%</td>
                                </tr>
                                { (row.mi_add_disc == null || row.mi_add_disc == "") &&
                                <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                    <td colSpan={2}></td>
                                    <td colSpan={3} style={{fontSize: 16, paddingBottom: 0,paddingTop: 0, fontWeight: 700, textAlign: 'right',color: '#000'}}>Final Price</td>
                                    <td style={{paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{NumberFormat(row.linetotal)}</td>
                                </tr>
                                }
                            </>
                            }  
                            { row.mi_add_disc != null && row.mi_add_disc != "" &&
                            <>
                                <tr key={`tr-` + index} style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                    <td colSpan={2}></td>
                                    <td colSpan={3} style={{fontSize: 16, paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{row.mi_ket_add_disc} ({row.mi_add_disc})</td>
                                    <td style={{paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{NumberFormat(row.m_disc_3)}%</td>
                                </tr>
                                <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                    <td colSpan={2}></td>
                                    <td colSpan={3} style={{fontSize: 16,paddingBottom: 0,paddingTop: 0, fontWeight: 700, textAlign: 'right',color: '#000'}}>Final Price</td>
                                    <td style={{paddingBottom: 0,paddingTop: 0, textAlign: 'right',color: '#000'}}>{NumberFormat(row.linetotal)}</td>
                                </tr>
                            </>
                            }    
                        </>
                    ))}
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderBottom: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5,color: '#000'}} colSpan={2}>Total Price</td>
                            <td style={{borderTop: 'none', textAlign: 'right', paddingTop: 0, paddingBottom: 0,color: '#000'}}>{NumberFormat(getState.total)}</td>
                        </tr>
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderTop: 'none', borderBottom: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5,color: '#000'}} colSpan={2}>Additional Discount</td>
                            <td style={{borderTop: 'none', textAlign: 'right', paddingTop: 0, paddingBottom: 0,color: '#000'}}>({NumberFormat(getState.deduction)})</td>
                        </tr>
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderTop: 'none', borderBottom: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5,color: '#000'}} colSpan={2}>Campaign Discount</td>
                            <td style={{borderTop: 'none', textAlign: 'right', paddingTop: 0, paddingBottom: 0,color: '#000'}}>({NumberFormat(getState.total_discount)})</td>
                        </tr>
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderTop: 'none', borderBottom: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5,color: '#000'}} colSpan={2}>DPP</td>
                            <td style={{borderTop: 'none', textAlign: 'right', paddingTop: 0, paddingBottom: 0,color: '#000'}}>{NumberFormat(getState.total_dpp)}</td>
                        </tr>
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderTop: 'none', borderBottom: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5,color: '#000'}} colSpan={2}>PPN</td>
                            <td style={{borderTop: 'none', textAlign: 'right', paddingTop: 0, paddingBottom: 0,color: '#000'}}>{NumberFormat(getState.total_ppn)}</td>
                        </tr>
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1, borderTop: 'none'}}>
                            <td style={{borderTop: 'none', paddingTop: 0, paddingBottom: 0}} colSpan={3}></td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom:5,color: '#000'}} colSpan={2}>Grand Total</td>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 0,color: '#000'}}>{NumberFormat(getState.grand_total)}</td>
                        </tr>
                    </tbody>
                </table>
                <div style={{fontSize:18, fontWeight: 500, textTransform: 'capitalize'}}>
                    Terbilang : {angkaTerbilang(Math.round(getState.grand_total))}
                </div>
                
            </div>
        </div>
  )
});

export default PrintPO;